import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNewspaper: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconNewspaper"><Path d="M8 9V11H11V9H8Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 3H17V11H22V17.5C22 19.2632 20.6961 20.7219 19 20.9646V21H5.5C3.567 21 2 19.433 2 17.5V3ZM18.5 19C19.3284 19 20 18.3284 20 17.5V13H17V17.5C17 18.3284 17.6716 19 18.5 19ZM6 17H13V15H6V17ZM6 13V7H13V13H6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNewspaper;
